export const legacyDescriptorSurfaceKinds = [
  'facet-registry',
  'openclaw-manifest',
  'runtime-manifest',
] as const;

export type LegacyDescriptorSurfaceKind = (typeof legacyDescriptorSurfaceKinds)[number];

export const legacyDescriptorSurfaceActions = [
  'backfill-descriptors',
  'shim-to-catalog',
  'keep-as-runtime-bundle',
] as const;

export type LegacyDescriptorSurfaceAction = (typeof legacyDescriptorSurfaceActions)[number];

export interface LegacyDescriptorSurface {
  id: string;
  name: string;
  kind: LegacyDescriptorSurfaceKind;
  path: string;
  owner: 'apps/api' | 'packages/openclaw' | 'examples/self-host-runtime';
  action: LegacyDescriptorSurfaceAction;
  issue: 854;
  legacyPluginIds: readonly string[];
  notes: string;
}

export const legacyDescriptorSurfaces = [
  {
    id: 'api-facet-registry',
    name: 'API facet registry',
    kind: 'facet-registry',
    path: 'apps/api/server/src/facet-registry.ts',
    owner: 'apps/api',
    action: 'backfill-descriptors',
    issue: 854,
    legacyPluginIds: [
      'textlayer',
      'llamaparse-fast',
      'llamaparse-premium',
      'llamaparse-agentic',
      'unstructured',
      'google-document-ai-ocr',
      'mistral-ocr',
      'mistral-ocr-annotated',
      'reducto-parse',
      'reducto-agentic',
      'mineru',
      'gemini-3-flash-minimal',
      'vlm-parsebench',
      'azure-di-layout',
      'chandra-ocr',
      'chandra-ocr-raw',
    ],
    notes: 'BUILTIN_FACETS is still the API-side parser/facet plugin list; migrate each parser preset into okra-plugin.jsonc rows or make this registry a catalog shim.',
  },
  {
    id: 'openclaw-plugin-manifest',
    name: 'OpenClaw plugin manifest',
    kind: 'openclaw-manifest',
    path: 'packages/openclaw/openclaw.plugin.json',
    owner: 'packages/openclaw',
    action: 'shim-to-catalog',
    issue: 854,
    legacyPluginIds: ['okrapdf'],
    notes: 'OpenClaw has a standalone configSchema manifest; keep it as a thin platform manifest while deriving catalog metadata from okra-plugin.jsonc.',
  },
  {
    id: 'self-host-runtime-manifest',
    name: 'Self-host runtime manifest',
    kind: 'runtime-manifest',
    path: 'examples/self-host-runtime/runtime.manifest.json',
    owner: 'examples/self-host-runtime',
    action: 'keep-as-runtime-bundle',
    issue: 854,
    legacyPluginIds: [],
    notes: 'runtime.manifest.json is a deploy/runtime bundle contract, not a catalog row; keep it tracked so it does not become a second plugin registry.',
  },
] as const satisfies readonly LegacyDescriptorSurface[];
